module.exports = __webpack_public_path__ + "static/media/logo-instagram-black.3d99bad8.svg";